import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { allCleanPowerFields } from './common/cleanPowerFields';
import { msg } from '@lingui/core/macro';
import { electricityUsageQuantityField } from './common/electricityFields';

export const electricityConsumptionMetadata = {
  displayName: msg({
    message: 'Facilities electricity consumption',
    context: 'Activity data schema name for facilities electricity consumption',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...allCleanPowerFields,
    ...buildingRevisionFields,
    quantity: electricityUsageQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
